import { render, staticRenderFns } from "./SetOfCriteriaTypes.vue?vue&type=template&id=ab2b3dac&"
import script from "./SetOfCriteriaTypes.vue?vue&type=script&lang=js&"
export * from "./SetOfCriteriaTypes.vue?vue&type=script&lang=js&"
import style0 from "./SetOfCriteriaTypes.vue?vue&type=style&index=0&id=ab2b3dac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports